import { render, staticRenderFns } from "./LayoutSecond.vue?vue&type=template&id=4a56378a"
import script from "./LayoutSecond.vue?vue&type=script&lang=js"
export * from "./LayoutSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports